import React, {useEffect, useState} from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import Header from "../../../components/Header";
import NavTabs from "../../../components/NavTabs";
import { 
    Column, 
    Legend, 
    Description, 
    GroupEditAndDelete, 
    GroupName 
} from "./styles";
import routes from "../../../routes/ecommerce.routes";
import api from "../../../service/api";
import { ToastContainer } from "react-toastify";
import { useQuery } from "react-query"
import FormGroupProduct from "../../../components/FormGroupProduct";
import { IGroupProduct } from "./interfaces";
import Table from "../../../components/Table";
import Thead from "../../../components/Thead";
import { openModal } from "../../../helpers/modalFunctions";
import Th from "../../../components/Th";
import Animation from "../../../components/Animation/animation";
import TableContentGroupsProducts from "../../../components/TableContentGroupsProducts";
import ModalCreateGroupProduct from "../../../components/ModalCreateGroupProduct";
import { getBlock } from "../../../service/getBlock";

const GroupProducts = (): React.ReactElement => {
    const login = useSelector((state: {login: any}) => state.login);
    const pageNumberDefault = 1
    const history = useHistory();
    const [ groups, setGroups ] = useState<Array<IGroupProduct>>([])
    const [page, setPage] = useState(pageNumberDefault);
    const [maxPage, setMaxPage] = useState(pageNumberDefault);
    const [refresh, setRefresh] = useState(false);
    
    useQuery(["getGroups", refresh], () => getGroups())

    useEffect(() => {
        if(login.user.groups.cm7a1 === false){
            history.push("/admin/dashboard");
        }
    }, []);

    const getGroups = async (): Promise<void> => {
        const { block } = await getBlock("/donations/camp/list", {
            sellerOwnerPayId: login.user.branchs.sellerOwnerPayId,
            page: page,
            maxPage: maxPage
        });

        setGroups(block.donationsCamp);
        setPage(block.page ?? pageNumberDefault);
        setMaxPage(block.maxPage ?? pageNumberDefault)
    }

    return (
        <div>
            <ToastContainer autoClose={2000} />
            <Header 
                title="Grupo de produtos" 
                subTitle="Crie e adicione grupos de produtos." 
                subTitleWidth={200}
            />
            <NavTabs tabs={routes}/>
            <ModalCreateGroupProduct
                refresh={refresh}
                setRefresh={setRefresh}
            />
            <Table
                id="groupProducts"
                buttonText="Adicionar grupo"
                showAddButton={true}
                setIsAddFormVisible={() => openModal("addGroupProduct")}
                page={page}
                maximumPage={maxPage}
                setPage={setPage}
                nonFilterable
            >
                <Thead>
                    <tr>
                        <Th></Th>
                        <Th>Nome</Th>
                        <Th>Status</Th>
                        <Th>Valor inicial</Th>
                        <Th>Criação</Th>
                        <Th>Última edição</Th>
                    </tr>
                </Thead>
                    <tbody>
                        <TableContentGroupsProducts
                            listGroups={groups}
                        />
                    </tbody>
            </Table>
        </div>
    )
}

export default GroupProducts;